export type formatTypes = 'png' | 'jpeg' | 'svg' | 'base64';

export enum FormatType {
  Png = 'png',
  Jpeg = 'jpeg',
  Svg = 'svg',
  Base64 = 'base64',
}
